<template>
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-row>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Inizio</label>
                    <date-picker v-model="jsonData.dataInizio" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                </b-col>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Fine</label>
                    <date-picker v-model="jsonData.dataFine" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                </b-col>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 10px">
                    <b-button size="sm" variant="outline-danger outline-primary-noborder sa-margin-right float-sm-right" @click="onClickRimuovi" class="mb-2">
                        <i class="fas fa-minus"></i>
                        Rimuovi
                    </b-button>
                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickAggiungi" class="mb-2">
                        <i class="fas fa-plus"></i>
                        Aggiungi
                    </b-button>
                </b-col>
                <b-col v-for="(data, index) in jsonData.listaDettagli" :key="index" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <!--     <b-row>
                        
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            {{ index + 1 + ")" }}
                            <b-form-textarea v-if="!isReadOnly" v-model="jsonData.listaDettagli[index].dettaglio" rows="3" max-rows="6"></b-form-textarea>
                            <span v-else> {{ data.dettaglio }} </span>
                        </b-col>
                    </b-row> -->
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <div class="d-flex align-items-center">
                                <span class="me-2">{{ index + 1 + ")" }}</span>
                                <b-form-textarea v-if="!isReadOnly" v-model="jsonData.listaDettagli[index].dettaglio" rows="3" max-rows="6"></b-form-textarea>
                                <span v-else> {{ data.dettaglio }}</span>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
    components: { DatePicker },
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },

    data() {
        return {
            isPersonaRiferimento: true,
            jsonData: {},
            nomeProgetto: "OBIETTIVI DSM",
            pathResourche: "/rsapazientesrobiettividsm",
            params: "",
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione ? me.$route.query.idAccettazione : me.$route.params.id;
        let params = { obiettiviDsm: "SI" };
        me.params = JSON.stringify(params);
        me.jsonData = {
            idAccettazione: me.idAccettazione,
            params: me.params,
            nomeProgetto: me.nomeProgetto,
            dataInizio: new Date().getTime(),
            dataFine: null,
            listaDettagli: [{ dettaglio: "" }],
        };
        if (me.idRisorsa !== null) {
            me.loadData();
        }
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourche + "/" + me.idRisorsa, {}, me.resultResponseData, me.resultErrorData);
        },
        resultResponseData(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonData.nomeProgetto = me.nomeProgetto;
            me.jsonData.params = me.params;
            me.jsonData.idAccettazione = me.idAccettazione;
        },
        resultErrorData(error) {
            console.log(error.response.data.messaggio);
        },
        onClickAggiungi() {
            let me = this;
            me.jsonData.listaDettagli.push({ dettaglio: null });
        },
        onClickRimuovi() {
            let me = this;
            if (me.jsonData.listaDettagli.length > 1) {
                me.jsonData.listaDettagli.pop();
            }
        },
    },
};
</script>
